import { AxiosInstance } from "axios";
import { ongBaseApi } from "./ong-base-api";
import { OngBaseResponse } from "./ong-base-response";
import {
  CreateDeliveryIssuePayload,
  DeliveryIssue,
  UpdateDeliveryIssuePayload,
} from "../types/delivery-issue/delivery-issue";

export enum DeliveryIssueApiUrl {
  base = "/delivery-issue",
}

interface ListResponse {
  items: DeliveryIssue[];
}

class DeliveryIssueApi {
  private _api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this._api = api;
  }

  async create(
    payload: CreateDeliveryIssuePayload,
  ): Promise<OngBaseResponse<DeliveryIssue>> {
    return this._api.post(DeliveryIssueApiUrl.base, payload);
  }

  async listByDelivery(
    deliveryId: string,
  ): Promise<OngBaseResponse<ListResponse>> {
    return this._api.get(DeliveryIssueApiUrl.base, {
      params: { delivery_id: deliveryId },
    });
  }

  async update(
    id: string,
    payload: UpdateDeliveryIssuePayload,
  ): Promise<OngBaseResponse<DeliveryIssue>> {
    return this._api.patch(`${DeliveryIssueApiUrl.base}/${id}`, payload);
  }

  async delete(id: string): Promise<OngBaseResponse<void>> {
    return this._api.delete(`${DeliveryIssueApiUrl.base}/${id}`);
  }
}

export const deliveryIssueApi = new DeliveryIssueApi(ongBaseApi);
